export function isEnterPressed(e) {
    var code = e.which ? e.which : e.keyCode;
    return (code == 13);
}

//
// Helpers for handling browser events
//

//event hasn't property which IE  < 9
function isNumberKeyFromEvent(e) {
    return isNumberKey(e.which ? e.which : e.keyCode);
}

function isNumberKey(code) {
    return code >= 48 && code <= 57;
}

function isLiteralKeyFromEvent(e) {
    return isAcceptableKey(e.which ? e.which : e.keyCode);
}

function isAcceptableKey(code) {
    return isLiteralKey(code) || isAcceptableSymbol(code);
}
// 0-9A-Za-z
function isLiteralKey(code) {
    return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}
// space'-.
function isAcceptableSymbol(code) {
    return code == 32 || code == 39 || code == 45 || code == 46;
}

function getIntegerFromEvent(e) {
    return getInteger(e.target.value);
}

function getInteger(text) {
    const number = parseInt(text, 10);
    if (isNaN(number)) {
        return 0;
    }

    return number;
}


const isTabPressed = e => {
    const code = e.which ? e.which : e.keyCode;
    return (code == 9);
};

const isShiftPressed = e => e.shiftKey;

export { isNumberKeyFromEvent, isNumberKey, getIntegerFromEvent, getInteger, isLiteralKeyFromEvent, isTabPressed, isShiftPressed };
